import * as R from 'ramda';

import { AssetRequestCreateInput } from '@atom/types/assetRequest';
import { InventoryAssetDetailType } from '@atom/types/inventory';
import { PolicyAction } from '@atom/types/policy';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import UserSearch from './UserSearch';

import classes from './ardotCreate.module.css';

const styles = {
  search: {
    marginTop: '1rem',
  },
};

interface Props {
  createInputs: AssetRequestCreateInput;
  updateCreateInput: (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => void;
  asset: InventoryAssetDetailType;
}

const ApprovalSection = ({ createInputs, updateCreateInput, asset }: Props) => {
  const reviewerValue = isNilOrEmpty(createInputs?.reviewer)
    ? null
    : [createInputs.reviewer];
  const receiverValue = isNilOrEmpty(createInputs?.receiver)
    ? null
    : [createInputs.receiver];

  return (
    <>
      <div className={classes.transferTitle}>Approval</div>
      <div className={classes.approvalContainer}>
        <div className={classes.stepTitle}>
          Step 1: District/Division Review
        </div>
        <UserSearch
          value={reviewerValue}
          updateValue={newValue =>
            updateCreateInput(newValue[0]?.id, 'reviewer')
          }
          label="Reviewer (Division or District Head)"
          searchParams={{
            categoryId: asset?.categoryId,
            action: PolicyAction.REVIEW,
          }}
          style={styles.search}
        />
        <div className={classes.approvalSubtext}>
          An email will be sent to the user for approval of this transfer
          request.
        </div>
      </div>
      <div className={classes.approvalContainer}>
        <div className={classes.stepTitle}>Step 2: Receiver Approval</div>
        <UserSearch
          value={receiverValue}
          updateValue={newValue =>
            updateCreateInput(newValue[0]?.id, 'receiver')
          }
          label="Receiver"
          searchParams={{
            categoryId: R.pathOr(
              asset?.categoryId,
              ['toCategoryId'],
              createInputs,
            ),
            action: PolicyAction.RECEIVE,
          }}
          style={styles.search}
        />
        <div className={classes.approvalSubtext}>
          An email will be sent to the user for approval of this transfer
          request.
        </div>
      </div>
    </>
  );
};

export default ApprovalSection;
